export const ALL_WORK_SPACES = [
  {
    label: 'Work Space',
    field: 'work_space',
    sort: 'asc'
  },
  {
    label: 'Branch',
    field: 'branch',
    sort: 'asc'
  },
  {
    label: 'Building',
    field: 'building',
    sort: 'asc'
  },
  {
    label: 'Floor',
    field: 'floor',
    sort: 'asc'
  },
  {
    label: 'Slot Count',
    field: 'slot_count',
    sort: 'asc'
  },
  {
    label: 'Today Reserved Slots',
    field: 'reserved_slots',
    sort: 'asc'
  },
  {
    label: 'Today Free Slots',
    field: 'remain_slots',
    sort: 'asc'
  },
  {
    label: 'Calender',
    field: 'calender',
    sort: 'asc'
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'asc'
  },
];

export const RESERVED_SLOTS = [
  {
    label: 'Slot',
    field: 'slot',
    sort: 'asc'
  },
  {
    label: 'Employee Image',
    field: 'employee_image',
    sort: 'asc'
  },
  {
    label: 'Employee Name',
    field: 'employee_name',
    sort: 'asc'
  },
  {
    label: 'Designation',
    field: 'position',
    sort: 'asc'
  },
  {
    label: 'Group',
    field: 'group',
    sort: 'asc'
  },
];

export const NOTIFICATION_HEADERS = [
  {
    label: 'Date',
    field: 'date',
    sort: 'asc'
  },
  {
    label: 'Workspace',
    field: 'workspace',
    sort: 'asc'
  },
  {
    label: 'Title',
    field: 'title',
    sort: 'asc'
  },
  {
    label: 'Notification',
    field: 'notification',
    sort: 'asc'
  },
];

